export enum AddMenuItems {
    'Add Employees' = 1,
    'Add Projects' = 2,
    'Add R&D Activities' = 3,
    'Add Non-R&D Activities' = 4,
    'Add NWTs' = 5,
    'Fully Allocate Employees' = 6,
    'Edit Due Dates' = 7
}

export class AddMenuItemsOption {
    id: number;
    value: string;
    enabled: boolean;
    constructor(_id: number, _value: string, _enabled: boolean) {
        this.id = _id;
        this.value = _value;
        this.enabled = _enabled;
    }
}

export class AddMenuItemsOptions {
    options: AddMenuItemsOption[] = [];
    constructor() {
        for (var key in AddMenuItems) {
            var itemId = Number(key);
            if (!isNaN(itemId) && itemId!==6) {
                this.options.push(new AddMenuItemsOption(itemId, AddMenuItems[itemId], true));
            }
        }
    }
}

export class AddMenuItemsOptionsAllocateEmployees {
    options: AddMenuItemsOption[] = [];
    constructor() {
        for (var key in AddMenuItems) {
            var itemId = Number(key);
            if (!isNaN(itemId)) {
                this.options.push(new AddMenuItemsOption(itemId, AddMenuItems[itemId], true));
            }
        }
    }
}
